import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { cn } from "@/lib/utils";
import { AppStripItemConfig } from "./appStripTypes";

interface AppStripItemProps {
  item: AppStripItemConfig;
  isActive: boolean;
  onClick: () => void;
}

export default function AppStripItem({
  item,
  isActive,
  onClick,
}: AppStripItemProps) {
  const Icon = item.icon;

  const handleClick = () => {
    if (item.isExternal && item.externalUrl) {
      const separator = item.externalUrl.includes("?") ? "&" : "?";
      const url = `${item.externalUrl}${separator}forceReauth=true`;
      console.log("[AppStripItem] Opening external URL:", url);
      window.open(url, "_blank", "noopener,noreferrer");
    } else {
      onClick();
    }
  };

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <button
          aria-label={item.name}
          className={cn(
            "relative flex h-10 w-10 items-center justify-center rounded-lg transition-all duration-200",
            "hover:bg-gray-200 dark:hover:bg-white/10",
            isActive && !item.isExternal
              ? "bg-gray-200 text-gray-900 dark:bg-white/15 dark:text-white"
              : "text-gray-500 hover:text-gray-900 dark:text-slate-400 dark:hover:text-white",
          )}
          onClick={handleClick}
          type="button"
        >
          {/* Active indicator bar */}
          {isActive && !item.isExternal && (
            <div className="absolute left-0 top-1/2 h-6 w-1 -translate-y-1/2 rounded-r-full bg-primary" />
          )}
          <Icon className="h-5 w-5" />
        </button>
      </TooltipTrigger>
      <TooltipContent align="center" side="right" sideOffset={8}>
        <span className="text-xs font-medium">{item.name}</span>
      </TooltipContent>
    </Tooltip>
  );
}
